
export default function isObjectOrFunction(value) {
  return (typeof value === 'object' || typeof value === 'function') &&
    value !== null
    ? true
    : false
}
